module.exports = __webpack_public_path__ + "static/media/CC_NG_Referral_HU.8b2bfc98.png";